/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  Modal,
  Form,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import CropModal from "../../Components/Common/CropModal";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import BreadCrumb from "../../Components/Common/BreadCrumb";
import dummyImg from "../../assets/images/users/user-dummy-img.jpg";
import TableContainer from "../../Components/Common/TableContainer";
import {
  createBanner,
  deleteBanner,
  listBanner,
  updateBanner,
} from "./_requests";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useProfile } from "../../Components/Hooks/UserHooks";

const Banner = () => {
  const { userProfile } = useProfile();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [Banners, setBanners] = useState<any>([]);
  const [modal, setModal] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [BannerToDeleteId, setBannerToDeleteId] = useState<string>("");
  const [BannerToDeleteName, setBannerToDeleteName] = useState<string>("");
  const [Duplicate, setDuplicate] = useState<any>("");
  const [previewImage, setPreviewImage] = useState<any>("");
  const [imageError, setImageError] = useState<string | null>(null);

  // Cropper states
  const [cropModal, setCropModal] = useState<boolean>(false);
  const [imageToCrop, setImageToCrop] = useState<string | null>(null);

  const toggle = useCallback(() => {
    setModal(!modal);
    setDuplicate("");
    setImageError("");
  }, [modal]);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files[0]) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target?.result) {
          setImageToCrop(e.target.result as string);
          setCropModal(true);
        }
      };
      reader.readAsDataURL(file);
      // Reset input so the same file can be selected again
      event.target.value = "";
    }
  };

  const handleCropSave = (croppedFile: File) => {
    validation.setFieldValue("image", croppedFile);
    setPreviewImage(URL.createObjectURL(croppedFile));
    setImageError(null);
  };

  const toggleDeleteModal = useCallback(() => {
    setDeleteModalOpen(!deleteModalOpen);
  }, [deleteModalOpen]);

  const [Bannercaccess, setBannercaccess] = useState<any>();

  const onClickDelete = useCallback(
    (Banner: any) => {
      setBannerToDeleteName(Banner.title); // Backend uses title
      setBannerToDeleteId(Banner.id);
      toggleDeleteModal();
    },
    [toggleDeleteModal]
  );

  const confirmDelete = (BannerId: any) => {
    if (BannerId) {
      deleteBanner(BannerId, userProfile?.userId || 0).then((res: any) => {
        if (res && res.status) {
          toast.success("Banner deleted successfully", {
            autoClose: 3000,
          });
          fetchBanners();
        } else {
          toast.error((res && res.message) || "Failed to delete Banner", {
            autoClose: 3000,
          });
        }
      });
    }
    toggleDeleteModal();
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = () => {
    listBanner().then((res: any) => {
      setBanners(res.data || []);
    });
  };

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      title: "", // Changed from name to title
      image: "",
      link: "", // Added link
      order_by: 0, // Added order_by
      is_enable: true, // Changed from enable_disable_status
    },
    validationSchema: Yup.object().shape({
      title: Yup.string().required("Please enter title"),
      image: Yup.mixed().test("image", "Please select image", (value) => {
        if (isEdit) return true;
        return !!value;
      }),
    }),
    onSubmit: (values: any) => {
      const formData = new FormData();
      formData.append("title", values.title);
      if (values.image) {
        // IMPORTANT: Backend expects 'imageNew' for updates, 'image' for create
        formData.append(isEdit ? "imageNew" : "image", values.image);
      }
      formData.append("link", values.link || "");
      formData.append("order_by", String(values.order_by || 0));
      formData.append("is_enable", values.is_enable ? "1" : "0");
      formData.append(isEdit ? "updated_by" : "created_by", userProfile?.userId || "0");

      if (isEdit) {
        updateBanner(formData, values.id).then((res: any) => {
          if (res && res.status) {
            toast.success("Banner updated successfully", {
              autoClose: 3000,
            });
            fetchBanners();
            toggle();
          } else {
            setDuplicate(res.message);
          }
        });
      } else {
        createBanner(formData).then((res: any) => {
          if (res && res.status) {
            toast.success("Banner created successfully", {
              autoClose: 3000,
            });
            fetchBanners();
            toggle();
          } else {
            setDuplicate(res.message);
          }
        });
      }
    },
  });

  const handleBannerClick = useCallback(
    (bannerData: any) => {
      validation.setValues({
        id: bannerData.id,
        title: bannerData.title,
        image: "",
        link: bannerData.link || "",
        order_by: bannerData.order_by || 0,
        is_enable: !!bannerData.is_enable,
      });
      setPreviewImage(bannerData.image);
      setIsEdit(true);
      toggle();
    },
    [toggle, validation]
  );

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        enableColumnFilter: false,
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "Image",
        accessorKey: "image",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <div className="avatar-lg bg-light rounded p-1">
            <img
              src={cell.row.original.image || dummyImg}
              alt=""
              className="img-fluid d-block h-100 object-fit-contain"
            />
          </div>
        ),
      },
      {
        header: "Title",
        accessorKey: "title",
        enableColumnFilter: false,
      },
      {
        header: "Order",
        accessorKey: "order_by",
        enableColumnFilter: false,
      },
      {
        header: "Action",
        cell: (cellProps: any) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item edit" title="Edit">
                <Link
                  to="#"
                  className="text-primary d-inline-block edit-item-btn"
                  onClick={() => {
                    handleBannerClick(cellProps.row.original);
                  }}
                >
                  <i className="ri-pencil-fill fs-16"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Remove">
                <Link
                  to="#"
                  className="text-danger d-inline-block remove-item-btn"
                  onClick={() => {
                    onClickDelete(cellProps.row.original);
                  }}
                >
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleBannerClick, onClickDelete]
  );

  const addBanner = () => {
    setIsEdit(false);
    const nextOrder = (Array.isArray(Banners) ? Banners.length : 0) + 1;
    validation.resetForm();
    validation.setValues({
      id: "",
      title: "",
      image: "",
      link: "",
      order_by: nextOrder,
      is_enable: true,
    });
    setPreviewImage("");
    setImageError("");
    toggle();
  };
  document.title = " Paal Dappa | Admin panel";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Banner" pageTitle="Dashboard" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <h5 className="card-title mb-0">Banner List</h5>
                    </div>
                    <div className="col-sm-auto">
                      <button
                        type="button"
                        className="btn text-white add-btn"
                        style={{ backgroundColor: "#28a8df" }}
                        onClick={addBanner}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Add
                        Banner
                      </button>
                    </div>
                  </Row>
                </CardHeader>
                <div className="card-body pt-0">
                  <TableContainer
                    columns={columns}
                    data={Banners || []}
                    isGlobalFilter={true}
                    customPageSize={10}
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap mb-0"
                    SearchPlaceholder="Search Banner..."
                  />

                  <Modal isOpen={modal} toggle={toggle} centered>
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      {!!isEdit ? "Edit Banner" : "Add Banner"}
                    </ModalHeader>
                    <Form
                      className="tablelist-form"
                      onSubmit={(e: any) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <Input type="hidden" name="id" value={validation.values.id || ""} />
                        <div className="mb-4 text-center">
                          <div className="d-inline-block">
                            <div className="position-relative mb-2">
                              {/* Improved Preview Container for Wide Banners */}
                              <div className="border rounded bg-light p-2 mx-auto" style={{ maxWidth: '300px', minWidth: '150px' }}>
                                <div className="w-100 d-flex align-items-center justify-content-center overflow-hidden rounded">
                                  <img
                                    src={previewImage || dummyImg}
                                    alt="Preview"
                                    className="img-fluid"
                                    style={{ maxHeight: '150px', objectFit: 'contain' }}
                                  />
                                </div>
                              </div>

                              {/* Action Buttons Below Preview */}
                              <div className="mt-3 d-flex justify-content-center gap-2">
                                <Label
                                  htmlFor="banner-image-input"
                                  className="btn btn-light btn-sm border d-flex align-items-center gap-1 cursor-pointer mb-0"
                                  title="Upload Image"
                                >
                                  <i className="ri-image-add-line"></i>
                                  {previewImage && previewImage !== dummyImg ? "Change" : "Select"} Image
                                </Label>

                                {previewImage && previewImage !== dummyImg && (
                                  <Button
                                    type="button"
                                    color="primary"
                                    size="sm"
                                    outline
                                    className="d-flex align-items-center gap-1"
                                    onClick={() => {
                                      setImageToCrop(previewImage);
                                      setCropModal(true);
                                    }}
                                    title="Crop Image"
                                  >
                                    <i className="ri-crop-2-line"></i> Crop
                                  </Button>
                                )}
                              </div>

                              <Input
                                name="image"
                                className="form-control d-none"
                                id="banner-image-input"
                                type="file"
                                accept="image/png, image/jpeg"
                                onChange={handleImageChange}
                              />
                            </div>
                          </div>

                          {/* Requirements Hint */}
                          <div className="mt-2">
                            <span className="badge bg-light text-muted border p-2">
                              <i className="ri-information-line me-1 text-info"></i>
                              Required: 1080px × 500px
                            </span>
                          </div>

                          {imageError && (
                            <div className="text-danger mt-2 small">{imageError}</div>
                          )}
                          {validation.touched.image && validation.errors.image && (
                            <div className="text-danger mt-2 small">{validation.errors.image}</div>
                          )}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="title" className="form-label">
                            Title <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="title"
                            type="text"
                            className="form-control"
                            id="title"
                            placeholder="Enter title"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.title || ""}
                            invalid={
                              validation.touched.title && validation.errors.title
                                ? true
                                : false
                            }
                          />
                          {validation.touched.title && validation.errors.title ? (
                            <FormFeedback type="invalid">
                              {validation.errors.title}
                            </FormFeedback>
                          ) : null}
                          {Duplicate && (
                            <div className="text-danger mt-2">{Duplicate}</div>
                          )}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="link" className="form-label">
                            Button Link
                          </Label>
                          <Input
                            name="link"
                            type="text"
                            className="form-control"
                            id="link"
                            placeholder="Enter link"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.link || ""}
                          />
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="order_by" className="form-label">
                            List Order
                          </Label>
                          <Input
                            name="order_by"
                            type="number"
                            className="form-control"
                            id="order_by"
                            placeholder="Enter order"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.order_by || 0}
                          />
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Enable Banner</Label>
                          <div className="form-check form-switch">
                            <Input
                              type="switch"
                              name="is_enable"
                              checked={validation.values.is_enable}
                              onChange={validation.handleChange}
                            />
                          </div>
                        </div>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button color="light" onClick={toggle}>
                            Close
                          </Button>
                          <Button
                            type="submit"
                            style={{
                              backgroundColor: "#28a8df",
                              borderColor: "#28a8df",
                            }}
                            className="text-white add-btn"
                          >
                            {!!isEdit ? "Update" : "Add Banner"}
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>

                  <Modal isOpen={deleteModalOpen} toggle={toggleDeleteModal} centered>
                    <ModalHeader toggle={toggleDeleteModal}>
                      Confirm Deletion
                    </ModalHeader>
                    <ModalBody>
                      Are you sure you want to delete the Banner{" "}
                      <strong>{BannerToDeleteName}</strong>?
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn text-white add-btn me-1"
                        style={{
                          backgroundColor: "#28a8df",
                          borderColor: "#28a8df",
                        }} onClick={toggleDeleteModal}>
                        Cancel
                      </Button>
                      <Button
                        className="btn text-white add-btn me-1"
                        style={{
                          backgroundColor: "#28a8df",
                          borderColor: "#28a8df",
                        }}
                        onClick={() => {
                          confirmDelete(BannerToDeleteId);
                          setModal(false);
                        }}
                      >
                        Delete
                      </Button>
                    </ModalFooter>
                  </Modal>

                  <CropModal
                    isOpen={cropModal}
                    toggle={() => setCropModal(false)}
                    imageSrc={imageToCrop}
                    onCropSave={handleCropSave}
                    targetWidth={1080}
                    targetHeight={500}
                    title="Banner Image Crop"
                  />
                </div>
              </Card>
            </Col>
          </Row>
          <ToastContainer closeButton={false} limit={1} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Banner;
